<template>
  <div class="user-list">
    <template v-if="list.length">
      <div
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="handleItemClick(item)"
      >
        <div
          :class="[
            'item-checkbox',
            item.checked ? 'item-checkbox_ischecked' : 'item-checkbox',
          ]"
          style="margin-right: 8px"
        ></div>
        <div
          :title="
            item.accountName + '(' + item.name + ')-' + item.organizationName
          "
        >
          {{ item.accountName }}({{ item.name }})-{{ item.organizationName }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="noMember">未搜索到人员</div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['list'],
  data() {
    return {}
  },
  methods: {
    handleItemClick(item) {
      this.$emit('change', item)
    },
  },
}
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.list-item {
  display: flex;
  align-items: center;
  margin-top: 12px;
  cursor: pointer;
}
.item-checkbox {
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border: 1px solid #dcdfe6;
  transition: all 0.15s ease-in 0.05s;
}
.item-checkbox_ischecked {
  position: relative;
  background-color: #409eff;
  border-color: #409eff;
  box-sizing: border-box;
  &::after {
    box-sizing: content-box;
    content: '';
    border: 1px solid #fff;
    border-left: 0 !important;
    border-top: 0 !important;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    width: 3px;
    transition: all 0.15s ease-in 0.05s;
    transform-origin: center;
    transform: rotate(45deg) scaleY(1);
  }
}
.noMember {
  color: rgba(2, 21, 37, 0.45);
  font-size: 12px;
}
</style>
